define.alias("shared/components/shared/app-footer", "calendar/components/shared/app-footer");